import { render, staticRenderFns } from "./VirtualDispatching.vue?vue&type=template&id=7c70c3ec&scoped=true&"
import script from "./VirtualDispatching.vue?vue&type=script&lang=js&"
export * from "./VirtualDispatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70c3ec",
  null
  
)

export default component.exports